import { Link } from "react-router-dom";

const Header = () => {
    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-40 w-full border-b border-border bg-[#FAF9F6]/85 backdrop-blur-md"
        >
            <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 md:px-10">
                <Link
                    to="/"
                    data-testid="site-logo"
                    className="font-serif text-2xl font-medium tracking-tight text-foreground"
                >
                    Slate
                    <span className="ml-1 text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
                        / Get-Slate.ai
                    </span>
                </Link>

                <nav className="hidden items-center gap-8 text-sm text-muted-foreground md:flex">
                    <a href="#how-it-works" data-testid="nav-how" className="slate-link hover:text-foreground">
                        How it works
                    </a>
                    <a href="#case-study" data-testid="nav-story" className="slate-link hover:text-foreground">
                        Maggie&apos;s story
                    </a>
                    <a href="#pricing" data-testid="nav-pricing" className="slate-link hover:text-foreground">
                        Pricing
                    </a>
                    <a href="#faq" data-testid="nav-faq" className="slate-link hover:text-foreground">
                        FAQ
                    </a>
                </nav>

                <Link
                    to="/apply"
                    data-testid="header-cta-apply"
                    className="rounded-sm border border-primary bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground transition-colors hover:bg-foreground"
                >
                    Start a Campaign
                </Link>
            </div>
        </header>
    );
};

export default Header;
